import { A as A11y, N as Navigation, S as Swiper } from './a11y-CZpEUmxp.js';
import { P as Pagination } from './pagination-Dw_WzC0k.js';
import { A as Autoplay, S as Scrollbar } from './autoplay-BCBJe3dL.js';

if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-swiper]');

      this.swiperOptions = {
        modules: [A11y, Autoplay, Navigation, Pagination, Scrollbar],
        threshold: 10,
      };

      // Check if we have extra options on the HTML
      if (this.swiperElement.dataset && this.swiperElement.dataset.options) {
        const jsonOptions = JSON.parse(this.swiperElement.dataset.options);

        if (jsonOptions) {
          this.swiperOptions = {
            ...this.swiperOptions,
            ...jsonOptions,
          };
        }
      }

      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      // Only do it once, not on every web component render.
      window.onload = () => {
        this.init();
      };
    }

    init() {
      // For product-slider, we don't need to fetch additional content
      // since products are already rendered server-side
      // Just ensure the swiper is properly initialized
      this.swiperInstance.update();

      if (this.swiperOptions.navigation) {
        this.swiperInstance.navigation.init();
        this.swiperInstance.navigation.update();
      }
      if (this.swiperOptions.pagination) {
        this.swiperInstance.pagination.init();
        this.swiperInstance.pagination.update();
      }
      if (this.swiperOptions.scrollbar) {
        this.swiperInstance.scrollbar.init();
        this.swiperInstance.scrollbar.updateSize();
      }
    }
  }

  window.ProductSlider = ProductSlider;

  customElements.define('product-slider', ProductSlider);
}
